<template>
  <!-- 客户出仓日志 -->
  <div class="Box">
    <el-card class="mb5">
      <el-form>
        <el-row type="flex" justify="start" style="flex-wrap: wrap;align-items: center">
          <el-col :span="5">
            <el-form-item style="width: 90%">
              <el-select v-model="numType" @change="numChange">
                <el-option :label="$t('GlobalSetObj.waybillNumber')" :value="1" />
                <el-option :label="$t('GlobalSetObj.ScanNumber')" :value="2" />
              </el-select>
              <el-input
                v-model="numberList"
                :placeholder="$t('collectionCenter.BatchQuery')"
                autosize
                type="textarea"
                style="width: 100%"
                @blur="handleNumberListChange"
                @keydown.enter.native="BlockNewlineNum"
              /><!-- 支持批量查询(回车换行分割) -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item style="width: 90%">
              <el-select
                v-model="queryForm.params.dataType"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                @change="changeDateType"
              >
                <el-option key="1" :label="$t('collectionCenter.outboundTime')" :value="1" />
                <el-option key="2" :label="$t('GlobalSetObj.TimeOfOrder')" :value="2" />
              </el-select>
              <el-date-picker
                v-model="timeValue"
                :clearable="false"
                :default-time="['00:00:00', '23:59:59']"
                :end-placeholder="$t('collectionCenter.EndTime')"
                :range-separator="$t('collectionCenter.to')"
                :start-placeholder="$t('collectionCenter.StartTime')"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                size="small"
                @change="dateChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!--  客户   -->
            <el-form-item :label="$t('orderImport.client')" style="width: 90%">
              <el-select
                v-model="queryForm.params.customerId"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                filterable
                size="small"
                style="width: 100%"
              >
                <!-- shein--24005  szanjun--24020 kwai--24009  -->
                <el-option label="shein" :value="24005" />
                <el-option label="kwai" :value="24009" />
                <el-option label="szanjun" :value="24020" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-button
              icon="el-icon-search"
              size="mini"
              type="primary"
              @click="searchClick"
            >{{ $t('newOrder.search') }}
            </el-button><!-- 搜索 -->
            <el-button
              icon="el-icon-refresh"
              size="mini"
              @click="resetClick"
            >{{ $t('collectionCenter.reset') }}
            </el-button><!-- 重置 -->
          </el-col>
        </el-row>
      </el-form>
      <el-divider />
    </el-card>
    <el-card>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        class="table-class"
      >
        <el-table-column
          :label="$t('CenterForSorting.ind')" type="index" width="60"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="waybillNumber"
          align="center"
          :label="$t('GlobalSetObj.waybillNumber')"
        /><!-- 运单号 -->
        <el-table-column
          prop="scanOrderNumber"
          align="center"
          :label="$t('GlobalSetObj.ScanNumber')"
        /><!-- 扫描单号 -->
        <el-table-column
          prop="customerName"
          align="center"
          :label="$t('orderImport.client')"
        /><!-- 客户 -->
        <el-table-column
          prop="createOrderTime"
          align="center"
          :label="$t('GlobalSetObj.TimeOfOrder')"
        /><!-- 下单时间 -->
        <el-table-column
          prop="customerSendTime"
          align="center"
          :label="$t('collectionCenter.outboundTime')"
        /><!-- 出仓时间 -->
        <el-table-column
          prop="customerSendImg"
          align="center"
          :label="$t('collectionCenter.outboundPhotos')"
        ><!-- 出仓照片 -->
          <template slot-scope="scope">
            <div
              v-if="scope.row.customerSendImg"
              style="color: #5bc6f5; cursor: pointer"
              @click="clickImg(scope.row)"
            >{{ $t('home.clickSee') }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="right">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="searchClick1"
          @size-change="searchClick"
        />
      </div>
    </el-card>

    <!--  大图预览  -->
    <!--  style="display: none"不会出现背景显示多余图片的问题  -->
    <el-image
      ref="previewImage"
      style="display: none"
      :src="currentImageList.img"
      :preview-src-list="currentImageList.imgArr"
      fit="contain"
    />
  </div>
</template>

<script>
import { customerSendPage } from '@/api/orderApi';
import dayjs from 'dayjs';
export default {
  name: 'CustomerOutboundLog',
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          customerId: '',
          waybillNumberList: [], // 运单号列表
          scanOrderNumberList: [], // 扫描单号列表
          startTime: '',
          endTime: '',
          dataType: 1 // 1 客户出仓时间 2 下单时间
        }
      },
      timeValue: [],
      numType: 1,
      numberList: '',
      tableData: [],
      total: 0,
      currentImageList: {
        img: '',
        imgArr: []
      }
    };
  },
  created() {
    this.default();
    this.searchClick();
  },
  methods: {
    default() {
      const d = new Date();
      const day = dayjs(d).format('YYYY-MM-DD');
      this.timeValue = [day + ' 00:00:00', day + ' 23:59:59'];
      this.numType = 1;
      this.numberList = '';
      this.queryForm = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          customerId: '',
          waybillNumberList: [], // 运单号列表
          scanOrderNumberList: [], // 扫描单号列表
          startTime: day + ' 00:00:00',
          endTime: day + ' 23:59:59',
          dataType: 1 // 1 客户出仓时间 2 下单时间
        }
      };
    },
    changeDateType() {
      const d = new Date();
      const day = dayjs(d).format('YYYY-MM-DD');
      this.timeValue = [day + ' 00:00:00', day + ' 23:59:59'];
      this.queryForm.params.startTime = day + ' 00:00:00';
      this.queryForm.params.endTime = day + ' 23:59:59';
    },
    dateChange(val) {
      if (val === null) {
        this.timeValue = [];
        this.queryForm.params.startTime = '';
        this.queryForm.params.endTime = '';
        return;
      }
      this.queryForm.params.startTime = val[0];
      this.queryForm.params.endTime = val[1];

      if (this.queryForm.params.endTime) {
        const endTime = dayjs(this.queryForm.params.startTime).subtract(-1, 'month').format('YYYY-MM-DD') + ' 23:59:59';
        if (this.queryForm.params.endTime > endTime) {
          this.$message({
            // '只允许查1个月内的数据'
            message: this.$t('collectionCenter.OnlyAllowedOneMonthsOfData'),
            type: 'warning'
          });
          const d = new Date();
          const today = dayjs(d).format('YYYY-MM-DD');
          this.timeValue = [today + ' 00:00:00', today + ' 23:59:59'];
          this.queryForm.params.startTime = today + ' 00:00:00';
          this.queryForm.params.endTime = today + ' 23:59:59';
        }
      }
    },
    BlockNewlineNum(e) {
      if (this.numberList) {
        const numbers = this.numberList.split(/[\r\n]+/).filter(item => item.trim() !== '');
        if (numbers.length >= 2000) {
          e.preventDefault();
          return;
        }
      }
    },
    numChange() {
      this.numberList = '';
      this.queryForm.params.waybillNumberList = [];
      this.queryForm.params.scanOrderNumberList = [];
    },
    handleNumberListChange() {
      if (!this.numberList) {
        this.queryForm.params.waybillNumberList = [];
        this.queryForm.params.scanOrderNumberList = [];
        return;
      }
      let numbers = this.numberList.split(/[\r\n]+/).filter(item => item.trim() !== '');
      if (numbers.length > 2000) {
        this.$message({
          message: this.$t(this.$t('collectionCenter.intercep2')),
          type: 'warning'
        });
        numbers = numbers.slice(0, 2000);
        this.numberList = numbers.join('\n');
      }
      this.queryForm.params.waybillNumberList = [];
      this.queryForm.params.scanOrderNumberList = [];
      if (this.numType === 1) {
        this.queryForm.params.waybillNumberList = numbers;
      } else {
        this.queryForm.params.scanOrderNumberList = numbers;
      }
    },
    searchClick1() {
      if (this.timeValue && this.timeValue.length > 0 || this.numberList) {
        customerSendPage(this.queryForm).then(res => {
          if (res.code === 200) {
            this.tableData = res.data.records;
            this.total = res.data.total;
          }
        });
      } else {
        this.$message({
          message: this.$t('collectionCenter.PleaseSelectTime'),
          type: 'warning'
        });
      }
    },
    searchClick() {
      this.queryForm.pageNumber = 1;
      this.searchClick1();
    },
    resetClick() {
      this.default();
      this.searchClick();
    },
    clickImg(row) {
      if (row.customerSendImg) {
        let imgArr = [];
        if (Array.isArray(row.customerSendImg)) {
          imgArr = row.customerSendImg;
        } else if (typeof row.customerSendImg === 'string') {
          try {
            const parsed = JSON.parse(row.customerSendImg);
            if (Array.isArray(parsed)) {
              imgArr = parsed;
            } else {
              imgArr = [row.customerSendImg];
            }
          } catch (e) {
            imgArr = [row.customerSendImg];
          }
        } else {
          imgArr = [row.customerSendImg];
        }
        this.currentImageList = {
          img: imgArr[0],
          imgArr: imgArr
        };
        this.$nextTick(() => {
          this.$refs.previewImage && this.$refs.previewImage.clickHandler();
        });
      }
    }
  }
};
</script>
<style>
.el-image-viewer__next, .el-image-viewer__prev, .el-image-viewer__close {
  overflow: auto;
  background-color: #4e4f50;
}
</style>
<style lang="scss" scoped>
.Box{
  padding: 20px;
  box-sizing: border-box;
}
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
::v-deep .el-table.table-class th {
  background-color: #f2f2f2 !important;
  color: #0b0b0b;
}
</style>
